import { colors } from 'Constants/Colors';
import { MULTIPLE_CHOICE_ID, FREE_RESPONSE_ID } from 'Constants/General';
import { NO_EMPTY_NO_EMPTY_SPACES } from 'Constants/Regex';
import { toast } from 'sonner';

const useValidation = ({ formData, setFormData, t2 }) => {
  const validate = () => {
    const formQuestions = formData.questions;
    const temp = {};

    temp.evaluationName = formData.evaluationName.match(NO_EMPTY_NO_EMPTY_SPACES) ? t2('FormErrorEvaluationName') : '';

    if (formData.duration !== null) {
      temp.duration =
        formData.duration instanceof Date || Number.isInteger(formData.duration)
          ? ''
          : t2('FormErrorEvaluationDuration');
    }

    let totalPoints = 0;

    formQuestions.forEach((question, index) => {
      const questionType = question.evaluationQuestionTypeId;
      let hasCorrectAnswer;
      const formAnswers = question.answers.filter(answer => answer.response !== '');

      temp[`question-${question.id}_question`] =
        question.question.match(NO_EMPTY_NO_EMPTY_SPACES) || question.question.length < 6
          ? t2('FormErrorEvaluationQuestion')
          : '';
      temp[`question-${question.id}_value`] =
        question.value <= 0 || !Number.isInteger(question.value) ? t2('FormErrorEvaluationValue') : '';

      // Sumamos los puntos de cada pregunta
      totalPoints += question.value;

      if (questionType === MULTIPLE_CHOICE_ID) {
        formAnswers.forEach(answer => {
          if (answer.isCorrect) {
            hasCorrectAnswer = true;
          }
          temp[`question-${question.id}_answer-${answer.id}`] =
            (answer.response.match(NO_EMPTY_NO_EMPTY_SPACES) || answer.response.length < 1) &&
            index !== formAnswers.length - 1
              ? t2('FormErrorEvaluationAnswer')
              : '';
        });

        temp[`question-${question.id}_isCorrect`] = !hasCorrectAnswer ? t2('FormErrorEvaluationIsCorrect') : '';
        temp[`question-${question.id}_atLeastTwoAnswers`] =
          formAnswers.length < 2 ? t2('FormErrorEvaluationTwoAnswers') : '';
      } else if (questionType === FREE_RESPONSE_ID) {
        const answer = question.answers[0];
        temp[`question-${question.id}_answer-${answer.id}`] =
          (answer.response.match(NO_EMPTY_NO_EMPTY_SPACES) || answer.response.length < 1) &&
          index !== formAnswers.length - 1
            ? t2('FormErrorEvaluationAnswer')
            : '';
      }
    });

    if (totalPoints !== 100) {
      toast.error(t2('form.error.total_points'), {
        style: {
          backgroundColor: colors.RED,
          color: '#fff',
          fontWeight: 600,
          border: 'none',
        },
        richColors: true,
      });
      return false;
    }

    setFormData({
      ...formData,
      errors: { ...formData.errors, ...temp },
    });

    return Object.values(temp).every(x => x === '');
  };

  return {
    validate,
  };
};

export default useValidation;
